// extracted by mini-css-extract-plugin
export default {"changeBtn":"style_changeBtn__AEaZd","loadBtn":"style_loadBtn__53lPO","changeBlock":"style_changeBlock__Gs00E"};